import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import Description from './aboutMeComponents/Description';
import Summary from './aboutMeComponents/Summary';
import Brands from './aboutMeComponents/Brands';
import Sizes from './aboutMeComponents/Sizes';
import Reviews from './aboutMeComponents/Reviews';

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    minHeight: '71vh',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'space-evenly'
  },
  aboutSection: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      flexFlow: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  },
  rightSection: {
    width: '100%'
  }
});

const AboutMe = ({ classes, user, editRight }) => {
  const hasBrands = user.brands && user.brands.length > 0;
  const hasSizes = user.size_shoes || user.size_top || user.size_bottom;

  return (
    <div className={classes.root}>
      <Description editable={editRight} description={user.description} />
      <div className={classes.aboutSection}>
        <Summary user={user} editable={editRight} />
        <div className={classes.rightSection}>
          {(editRight || hasBrands) && (
            <Brands editable={editRight} user={user} />
          )}
          {(editRight || hasSizes) && (
            <Sizes user={user} editable={editRight} />
          )}
          {!editRight && !hasBrands && !hasSizes && <Reviews user={user} />}
        </div>
      </div>
      {(hasBrands || hasSizes) && <Reviews user={user} />}
      {editRight && !hasBrands && !hasSizes && <Reviews user={user} />}
    </div>
  );
};

export default withStyles(styles)(AboutMe);
